import { useRef } from "react";

export function useOverlayClose(onClose: () => void, closeOnOutsideClick: boolean) {
  const mouseDownTargetRef = useRef<EventTarget | null>(null);

  const handleOverlayMouseDown = (e: React.MouseEvent) => {
    mouseDownTargetRef.current = e.target;
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    const startedOnOverlay = mouseDownTargetRef.current === e.currentTarget;

    if (closeOnOutsideClick && startedOnOverlay && e.target === e.currentTarget) {
      onClose();
    }
  };

  return { handleOverlayMouseDown, handleOverlayClick };
}
